import { ScanResult } from "../../../../components/solidity_scan/SolidityScanResult";
import axios from "../../axios";

export const postSolidityScan = async (body: {
  contract_address: string;
  contract_platform: string;
  contract_chain: string;
}) => {
  const response = await axios.post("/scanners/solidity-scan", body);
  return response.data.scan_report as ScanResult;
};
